 import Carousel from "../components/carousel/carousel"
 import TestimonialSection from"../components/testimonial/testimonial";
// import Profilee from "../components/Tester/App";
// import Profile from "../components/cardss";
// import Timeline from "../components/TL/Timeline";
// import GroupExample from "../components/ourproduct";


export default function Home() {
  return <div>
    <br></br>
   <Carousel/>
   {/* <Profilee/>
   < Profile/> */}
   <br></br>
   <TestimonialSection/>
   {/* <Timeline/> */}
   <br></br>
{/* <GroupExample/> */}
  
  </div> 
}


